import {deepClone, getUrlParams} from 'xmgoing-utils';
import {systemParamsMap} from "@/main-page/ctls/hooks/useDatasHooks";
import {StorageUtils} from 'xmgoing-utils';


export function initFilterValueByType({valueType,propItem,pageModelsStore,filterValue,filterSubValue=''}){
  //如果是全局变量
  if(valueType==='vuexParams'){
    if(pageModelsStore&&pageModelsStore.state){
      //如果存在二级属性
      if(filterSubValue){
        //则需要判断一级属性为对象
        if(typeof(pageModelsStore.state[(unref(filterValue)+'').trim()])==='object'){
          propItem.filterValue=pageModelsStore.state[(unref(filterValue)+'').trim()][filterSubValue]||"";
        }else{
          propItem.filterValue="";
        }
      }else{
        propItem.filterValue=pageModelsStore.state[unref(filterValue)]||"";
      }
    }
  }
  if(valueType==='systemParams'){
    propItem.filterValue=systemParamsMap[unref(filterValue)]||`systemParams.${unref(filterValue)}`;
  }
  if(valueType==='sessionStore'){
    propItem.filterValue=StorageUtils.getSessionItem(unref(filterValue));
  }
  if(valueType==='aclField'){
    switch (filterValue){
      case 'id':
        propItem.filterValue=`userId`;
        break;
      case 'account':
        propItem.filterValue=`userCode`;
        break;
      case 'name':
        propItem.filterValue=`userName`;
        break;
      case 'roleName':
        propItem.filterValue=`roleName`;
        break;
      case 'roleId':
        propItem.filterValue=`roleId`;
        break;
      case 'tenantId':
        propItem.filterValue=`userOrgId`;
        break;
      case 'tenantName':
        propItem.filterValue=`userOrgName`;
        break;
      case 'deptId':
        propItem.filterValue=`userDepartId`;
        break;
      case 'deptName':
        propItem.filterValue=`userDepartName`;
        break;
      default:
        break;
    }
  }
}

/**
 * 获取普通过滤信息
 * @param filter
 * @param filterRelVal
 */
const getCommonFilterJson=function (filter,filterRelVal,pageModelsStore){
  filter=deepClone(filter);
  if(filter&&Array.isArray(filter)){
    filter.forEach((propItem)=>{
      const {valueType,filterValue,filterSubValue}=propItem;
      initFilterValueByType({valueType,propItem,pageModelsStore,filterValue,filterSubValue});
    })
  }
  if (filter && filter.length > 0) {
    return {filterRelVal, children: filter};
  } else {
    return {};
  }
}
/**
 * 获取过滤信息
 * @param filter
 * @param filterRelVal
 * @param pageModelsStore
 * @param extendFilterParams
 */
export function getFilterJson(filter, filterRelVal,pageModelsStore,extendFilterParams) {
  if(extendFilterParams){
    if(extendFilterParams.filter==null){
      extendFilterParams.filter=[];
    }
    if(filter==null){
      filter=[];
    }
    //如果关联模式不存在 则跟扩展模式进行合并
    if(filterRelVal==null){
      filter=[...filter,...extendFilterParams.filter];
    }
    //如果关联模式统一 则进行合并
    if(filterRelVal&&filterRelVal===extendFilterParams.filterRelVal){
      filter=[...filter,...extendFilterParams.filter];
    }
    //如果关联模式不统一，则进行提醒 以扩展查询模式为主
    if(filterRelVal&&filterRelVal!==extendFilterParams.filterRelVal){
      filter=[...extendFilterParams.filter];
      console.error("=======getFilterJson异常======")
    }
    return getCommonFilterJson(filter,filterRelVal,pageModelsStore);
  }else{
    return getCommonFilterJson(filter,filterRelVal,pageModelsStore);
  }
}

/**
 * 固定查询参数唯一键（与 initQueryParamsObj 写入 orderParams 的规则一致）
 */
function getQueryUserParamKey(item?: any) {
  if (!item?.paraName) {
    return '';
  }
  return item.condition ? `${item.paraName}_${item.condition}` : item.paraName;
}

/**
 * 合并表格与按钮的 queryUserParams，同键以按钮为准
 */
export function mergeQueryUserParams(gridParams?: any[], btnParams?: any[]) {
  const grid = Array.isArray(gridParams) ? gridParams : [];
  const btn = Array.isArray(btnParams) ? btnParams : [];
  if (!grid.length && !btn.length) {
    return undefined;
  }
  if (!grid.length) {
    return [...btn];
  }
  if (!btn.length) {
    return [...grid];
  }
  const btnKeys = new Set(btn.map(getQueryUserParamKey).filter(Boolean));
  return [...grid.filter((item) => !btnKeys.has(getQueryUserParamKey(item))), ...btn];
}

/**
 * 合并导出用 dataConfig：表格 queryUserParams 等由表格提供，导出按钮配置覆盖导出相关项
 */
export function resolveExportDataConfig(dataConfig?: any, gridObj?: any) {
  const gridConfig = unref(gridObj?.gridDataConfig) || {};
  const btnConfig = unref(dataConfig) || {};
  return {
    ...gridConfig,
    ...btnConfig,
    queryUserParams: mergeQueryUserParams(gridConfig.queryUserParams, btnConfig.queryUserParams),
    useQueryUrl: btnConfig.useQueryUrl || gridConfig.useQueryUrl,
    userDefUrl: btnConfig.userDefUrl ?? gridConfig.userDefUrl,
    domainCode: btnConfig.domainCode || gridConfig.domainCode,
  };
}

/** 互斥择优时判定「无有效值」（空串视为无值，可回落到备选） */
function isEmptyQueryParamValue(relValue) {
  return relValue == null || relValue === '' || relValue === 'undefined';
}

function resolveQueryParamRelValue(itemDb, pageModelsStore, editorRecord) {
  if (!itemDb) {
    return undefined;
  }
  const {filterValue, filterSubValue, valueType, flowParams} = itemDb;
  return getParamsRelVal({
    paramValType: valueType,
    paramVal: filterValue,
    varSubParam: filterSubValue,
    pageModelsStore,
    flowParams,
    editorRecord
  });
}

function writeQueryParamRelValue(itemDb, relValue, orderParams) {
  if (!itemDb?.paraName || relValue == null || relValue === 'undefined') {
    return;
  }
  const {paraName, condition} = itemDb;
  if (condition) {
    orderParams[paraName + '_' + condition] = relValue;
  } else {
    orderParams[paraName] = relValue;
  }
}

function hasWrittenQueryParamValue(orderParams, itemDb) {
  if (!itemDb?.paraName || !orderParams) {
    return false;
  }
  const key = itemDb.condition ? `${itemDb.paraName}_${itemDb.condition}` : itemDb.paraName;
  return orderParams[key] != null && orderParams[key] !== '';
}

/**
 * 必填请求参数是否缺失。开启备选参数时：主参与备选至少其一有值即可。
 */
export function isRequiredQueryUserParamMissing(itemDb, orderParams) {
  if (!itemDb?.required) {
    return false;
  }
  if (itemDb.hasAlternateParam && itemDb.alternateParam?.paraName) {
    return !hasWrittenQueryParamValue(orderParams, itemDb)
      && !hasWrittenQueryParamValue(orderParams, itemDb.alternateParam);
  }
  if (itemDb.condition == null || itemDb.condition === '') {
    return orderParams[itemDb.paraName] == null || orderParams[itemDb.paraName] === '';
  }
  return orderParams[itemDb.paraName + '_' + itemDb.condition] == null
    || orderParams[itemDb.paraName + '_' + itemDb.condition] === '';
}

/** 转成 watch 可稳定比较的值。空值也要留下，否则 undefined→'' 两边都是空列表，监听不触发。 */
function toLoadWhenChangeWatchValue(relValue) {
  // 仅序列化数组：ids 一类 vuex 常被原地 push，computed 必须遍历才能侦听。
  // 普通对象不序列化，避免大表单对象每次 JSON.stringify。
  if (Array.isArray(relValue)) {
    try {
      return JSON.stringify(relValue);
    } catch {
      return relValue;
    }
  }
  return relValue ?? '';
}

/**
 * 收集「值变化时刷新」需监听的取值；开启备选时一并监听备选。
 * 空值也会写入 target，保证参数被清空时同样能触发刷新。
 */
export function appendLoadWhenChangeWatchValues(item, pageModelsStore, editorRecord, target) {
  if (!item?.loadWhenChange || !Array.isArray(target)) {
    return;
  }
  const pushVal = (paramItem) => {
    if (!paramItem) {
      return;
    }
    const relValue = resolveQueryParamRelValue(paramItem, pageModelsStore, editorRecord);
    target.push(toLoadWhenChangeWatchValue(relValue));
  };
  pushVal(item);
  if (item.hasAlternateParam) {
    pushVal(item.alternateParam);
  }
}

/**
 * 初始化查询参数
 * @param itemDb
 * @param pageModelsStore
 * 开启备选时互斥择优：主参有值只写主参，否则备选有值只写备选，都空则都不写。
 */
export function initQueryParamsObj(itemDb,pageModelsStore,orderParams,editorRecord){
  if (!itemDb) {
    return;
  }
  if (itemDb.hasAlternateParam && itemDb.alternateParam?.paraName) {
    const primaryVal = resolveQueryParamRelValue(itemDb, pageModelsStore, editorRecord);
    if (!isEmptyQueryParamValue(primaryVal)) {
      writeQueryParamRelValue(itemDb, primaryVal, orderParams);
      return;
    }
    const altVal = resolveQueryParamRelValue(itemDb.alternateParam, pageModelsStore, editorRecord);
    if (!isEmptyQueryParamValue(altVal)) {
      writeQueryParamRelValue(itemDb.alternateParam, altVal, orderParams);
    }
    return;
  }
  const {filterValue, paraName, filterSubValue, valueType,condition,flowParams} = itemDb;
  const relValue = getParamsRelVal({
    paramValType: valueType,
    paramVal: filterValue,
    varSubParam: filterSubValue,
    pageModelsStore,
    flowParams,
    editorRecord
  });
  if (relValue != null && relValue !== "undefined") {
    condition?orderParams[paraName+"_"+condition] = relValue:orderParams[paraName] = relValue;
  }
}
/**
 * 获取查询参数
 * @param paramValType
 * @param paramVal
 * @param varSubParam
 * @param pageModelsStore
 */
export function getParamsRelVal({paramValType,paramVal,varSubParam,pageModelsStore,flowParams=[],editorRecord}){
  //如果是全局变量参数
  if(paramValType==='vuexParams'){
    if(pageModelsStore&&pageModelsStore.state){
      if(varSubParam){
        if(pageModelsStore.state[paramVal]){
         return  pageModelsStore.state[paramVal][varSubParam];
        }
      }
      return pageModelsStore.state[paramVal];
    }
  }
  //如果是自定义参数
  if(paramValType==="aclField"){
    return `systemAclField.${paramVal}`
  }
  if(paramValType==="autoFlow"){

    const flowParamsObj:any = {};
    if (flowParams && Array.isArray(flowParams)) {
      flowParams.forEach((itemDb) => {
        initQueryParamsObj(itemDb,pageModelsStore,flowParamsObj);
      })
    }


    if(varSubParam){
      return `autoFlow_${paramVal}`+`_${varSubParam}_${JSON.stringify(flowParamsObj)}`
    }
    return `autoFlow_${paramVal}_${JSON.stringify(flowParamsObj)}`
  }
  //系统变量值
  if(paramValType==='systemParams'){
    return  `systemParams.${paramVal}`;
  }

  if(paramValType==='params'){
    if((paramVal+'').indexOf("urlParams")>=0){
      const ary=paramVal.split(".");
      if(ary.length>1){
        const paramName=ary[1].split("}")[0];
        return getUrlParams(paramName,true);
      }
    }
    return  `systemParams.${paramVal}`;
  }

  if(paramValType==='sessionStore'){
    return StorageUtils.getSessionItem(paramVal);
  }

  if(paramValType==='record'){
    if(unref(editorRecord)){
      return unref(editorRecord)[paramVal];
    }
    return '';
  }
  //如果是自定义参数
  if(paramValType==="userDef"){
    return paramVal;
  }
  if(paramValType==="constant"){
    if(paramVal==="strEmpty"){
      return  ' is empty'
    }
    if(paramVal==="not empty"){
      return  ' not empty'
    }
    if(paramVal==="objectNull"){
      return  ' is null'
    }
    if(paramVal==="emptyOrNull"){
      return  ' is empty or null'
    }
    return  paramVal;
  }
}
